import axios from 'axios'
import React from 'react'
import './timesheets.css'
import EditTimesheet from '../CreateTimesheet/EditTimesheet/EditTimesheet'
import EditInvoice from './EditInvoice/EditInvoice'
import { baseUrl } from '../assets/Animations'
import SubmittingTimesheetPopup from './SubmittingTimesheetPopup/SubmittingTimesheetPopup'
import AdminCreateTimesheet from './AdminCreateTimesheet/AdminCreateTimesheet'
import ReportOfInvoicesGenerated from './ReportOfInvoicesGenerated/ReportOfInvoicesGenerated'
import AdminCreateInvoice from './AdminCreateInvoice/AdminCreateInvoice'
import OwnerMonthlyTimesheetOverview from './OwnerMonthlyTimesheetOverview/OwnerMonthlyTimesheetOverview'
import { changeTabs, enterHoverAnimation, leaveHoverAnimation } from './timesheetUtils'
import TimesheetsTab from './TimesheetsTab/TimesheetsTab'
import InvoicesTab from './InvoicesTab/InvoicesTab'
import UnbilledTab from './UnbilledTab/UnbilledTab'
import {
    countUnbilledActiveStudents,
    excludeStudentsAlreadyListed,
    filterFamiliesWithoutCurrentMonthLessons,
    findUnbilledActiveStudents,
    getCurrentCalendarPeriod,
    getDefaultBillingPeriod,
    parseAllTimesheetDataResponse,
} from './UnbilledTab/unbilledFamiliesUtils'
import TimesheetDateSelector from './TimesheetDateSelector/TimesheetDateSelector'
import SchoolTabsTimesheet from './SchoolTabsTimesheet/SchoolTabsTimesheet'
import TimesheetAndInvoiceQuickView from './TimesheetAndInvoiceQuickView/TimesheetAndInvoiceQuickView'

const SCHOOL_LIST = ['mma', 'lsma', 'tma', 'mor', 'psma', 'tem', 'den', 'tul']

const Timesheets = (props) => {
    const defaultBillingPeriod = React.useRef(getDefaultBillingPeriod()).current
    const currentCalendarPeriod = React.useRef(getCurrentCalendarPeriod()).current
    const [currentMonth] = React.useState(defaultBillingPeriod.month)
    const [currentYear] = React.useState(defaultBillingPeriod.year)
    const [month, setMonth] = React.useState(defaultBillingPeriod.month)
    const [year, setYear] = React.useState(defaultBillingPeriod.year)
    const [timesheets, setTimesheets] = React.useState([])
    const [invoices, setInvoices] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [students, setStudents] = React.useState([])
    const [tab, setTab] = React.useState('timesheets')
    const [schoolTab, setSchoolTab] = React.useState('mma')
    const [adminCreateTimesheet, setAdminCreateTimesheet] = React.useState(false)
    const [adminCreateInvoice, setAdminCreateInvoice] = React.useState(false)
    //const [openTimesheet, setOpenTimesheet] = React.useState(false)
    //const [openInvoice, setOpenInvoice] = React.useState(false)
    const [listOfFamilies, setListOfFamilies] = React.useState([])
    const [currentFamilyName, setCurrentFamilyName] = React.useState('')
    const [processingTimesheet, setProcessingTimesheet] = React.useState(false)
    const [invoicesHaveBeenGenerated, setInvoicesHaveBeenGenerated] = React.useState(false)
    const [listOfInvoicesGeneratedSuccessfully, setListOfInvoicesGeneratedSuccessfully] = React.useState([])
    const [listOfTeachersTimesheetsForThisMonth, setListOfTeachersTimesheetsForThisMonth] = React.useState([])
    const [activeFamilies, setActiveFamilies] = React.useState([])
    const [studentsWithoutCurrentMonthLessons, setStudentsWithoutCurrentMonthLessons] = React.useState(null)
    const [billingDataError, setBillingDataError] = React.useState('')
    const [billingDataLoading, setBillingDataLoading] = React.useState(true)
    const [quickView, setQuickView] = React.useState(false)
    const billingRequestSequence = React.useRef(0)
    
    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    React.useEffect(() => {
        let isCurrentRequest = true
        const endpoints = [`${baseUrl}/initialadminrequest`, `${baseUrl}/school-management`]
        const authHeader = {headers: { Authorization: `Bearer ${myToken}` }}

        Promise.all(endpoints.map((endpoint) => axios.get(endpoint, authHeader)))
        .then((res) => {
            if (!isCurrentRequest) return

            const familyData = Array.isArray(res[1].data) ? res[1].data : []
            const teacherData = (Array.isArray(res[0].data) ? res[0].data : [])
                .map((teacher) => ({...teacher, newStudentList: []}))

            familyData.forEach((family) => {
                if (family?.familyStatus !== 'Active') return

                const familyStudents = Array.isArray(family?.students) ? family.students : []
                familyStudents.forEach((student) => {
                    if (student?.studentStatus !== 'Active') return

                    const teacher = teacherData.find((item) => item.TeacherID === student.teachersId)
                    if (teacher) {
                        teacher.newStudentList.push({firstName: student.studentName, lastName: family.familyName})
                    }
                })
            })

            teacherData.sort((left, right) => right.newStudentList.length - left.newStudentList.length)
            setTeachers(teacherData)
            setStudents(familyData)
        })
        .catch((err) => console.log(err))

        return () => {
            isCurrentRequest = false
        }
    }, [myToken])

    React.useEffect(() => {
        changeTabs(tab, SCHOOL_LIST, schoolTab)
    }, [tab, schoolTab])

    React.useEffect(() => {
        if (!month || !year) return undefined

        const requestSequence = ++billingRequestSequence.current
        let isCurrentRequest = true
        setBillingDataError('')
        setBillingDataLoading(true)

        const authHeader = {headers: { Authorization: `Bearer ${myToken}` }}
        Promise.all([
            axios.get(`${baseUrl}/alltimesheetdata/${month}/${year}`, authHeader),
            axios.get(`${baseUrl}/dashboard/active-students-without-lessons`, {
                ...authHeader,
                params: {
                    month: currentCalendarPeriod.monthNumber,
                    year: currentCalendarPeriod.year,
                },
            }),
        ])
        .then(([billingResponse, calendarResponse]) => {
            if (!isCurrentRequest || requestSequence !== billingRequestSequence.current) return

            const billingData = parseAllTimesheetDataResponse(billingResponse.data)
            if (!Array.isArray(calendarResponse?.data?.students)) {
                throw new Error('The current-month calendar response did not include a student list.')
            }

            setTimesheets(billingData.timesheets)
            setInvoices(billingData.invoices)
            setActiveFamilies(billingData.activeFamilies)
            setStudentsWithoutCurrentMonthLessons(calendarResponse.data.students)
            setBillingDataLoading(false)
        })
        .catch((err) => {
            if (!isCurrentRequest || requestSequence !== billingRequestSequence.current) return

            console.log(err)
            setTimesheets([])
            setInvoices([])
            setActiveFamilies([])
            setStudentsWithoutCurrentMonthLessons(null)
            setBillingDataError(`Unable to load billing data for ${month} ${year}.`)
            setBillingDataLoading(false)
        })

        return () => {
            isCurrentRequest = false
        }
    }, [currentCalendarPeriod.monthNumber, currentCalendarPeriod.year, month, myToken, year])

    const allUnbilledActiveFamilies = React.useMemo(
        () => findUnbilledActiveStudents(activeFamilies, timesheets),
        [activeFamilies, timesheets]
    )
    const familiesNotBilled = React.useMemo(
        () => filterFamiliesWithoutCurrentMonthLessons(allUnbilledActiveFamilies, studentsWithoutCurrentMonthLessons),
        [allUnbilledActiveFamilies, studentsWithoutCurrentMonthLessons]
    )
    const otherUnbilledActiveFamilies = React.useMemo(
        () => excludeStudentsAlreadyListed(allUnbilledActiveFamilies, familiesNotBilled),
        [allUnbilledActiveFamilies, familiesNotBilled]
    )
    const unbilledActiveStudentsCount = React.useMemo(
        () => countUnbilledActiveStudents(familiesNotBilled),
        [familiesNotBilled]
    )

    const callForListOfFamilies = async (school) => {
        let res = await axios.get(`${baseUrl}/schoolsfamilies/${school}`, myHeader)
        let sortedList = res.data.sort((a, b) => {
            return(a.familyName < b.familyName) ? -1 : (a.familyName > b.familyName) ? 1 : 0
        })
        setListOfFamilies(sortedList)
    }

    const markTimesheetAsApproved = async (id) => {
        axios.post(`${baseUrl}/approvetimesheet`, {timesheetId: id})
        .then((res) => updateTimesheets(res.data))
        .catch((err) => console.log(err))
    }

    const getAllInvoices = async () => {
        let returnedInvoices = await axios.get(`${baseUrl}/invoices/${month}/${year}`, myHeader)
        setInvoices(returnedInvoices.data)
        setProcessingTimesheet(false)
        setCurrentFamilyName('')
    }

    const generateInvoicesFromTimesheet = async (id) => {
        try{
            setProcessingTimesheet(true)
            //SET CURSOR TO LOADING
            document.body.style.cursor = 'wait'
            document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "wait"    
            //FIND THE CORRECT TIMESHEET
            let theTimesheet = timesheets.find((sheet) => sheet.timesheetId === id)
            let listOfFamiliesWeTriedToGenerateInvoicesFor = []
            //INCASE TIMESHEET IS EMPTY
            if(theTimesheet.families.length === 0) {
                markTimesheetAsApproved(theTimesheet.timesheetId)
                props.setOpenTimesheet(false)
                document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "default"
            }
            //LOOP THROUGH THE TIMESHEET & GENERATE INVOICES FROM IT
            theTimesheet.families.forEach((theFam) => {
                let invoicesStatus = 'Created'
                //CHECK FOR <24HR CANCELLATIONS
                theFam.cancellations.forEach((cancellation) => { cancellation.cancellor === 'student less than 24hrs' && theFam.lessons.push({ id: cancellation.id, studentName: cancellation.student, lessonLength: cancellation.lessonLength, studentRate: 0, date: cancellation.date })})
                //LIST ALL TEACHERS THAT TEACH THIS FAMILY
                let arrayOfTeachers = []
                theFam.listOfFamilyStudents.forEach((famsStudent) => {
                    famsStudent.studentStatus === 'Scholarship' && (invoicesStatus = 'Scholarship')
                    if(famsStudent.studentStatus === 'Active') {
                        arrayOfTeachers.filter(e => e.teachersId === famsStudent.teachersId).length === 0 &&
                            famsStudent.teachersId === theTimesheet.teacherId ? arrayOfTeachers.push({teachersId: famsStudent.teachersId, submittedTimesheet: true}) : arrayOfTeachers.push({teachersId: famsStudent.teachersId, submittedTimesheet: false})
                    }
                })
                setCurrentFamilyName(theFam.familyName)
                listOfFamiliesWeTriedToGenerateInvoicesFor.push({name: theFam.familyName, generated: false})
                let teacherInvoice = {
                    familyId: theFam.id,
                    familyName: theFam.familyName,
                    waveCustomerId: theFam.familyWaveId,
                    monthYear: theTimesheet.monthYear,
                    lessonsToBeBilled: theFam.lessons,
                    extrasToBeBilled: theFam.extras,
                    email: theFam.email,
                    paymentMethod: '',
                    status: invoicesStatus,
                    teachers: arrayOfTeachers,
                    school: theTimesheet.school,
                    autoPay: false,
                    monthNumber: theTimesheet.monthNumber,
                    year: theTimesheet.year
                }
                axios.post(`${baseUrl}/teacherinvoices`, {teacherInvoice})
                .then((res) => {
                    listOfFamiliesWeTriedToGenerateInvoicesFor.forEach((fam) => fam.name === res.data.familyName && (fam.generated = true))
                    document.body.style.cursor = 'default'
                    document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "default"
                    setInvoices([...invoices, res.data])
                    markTimesheetAsApproved(id)
                    props.setOpenTimesheet(false)
                    props.setShowNotes(false)
                })
                .catch((err) => {
                    console.log(err)
                    props.setOpenTimesheet(false)
                    props.setShowNotes(false)
                })
            })
            setInvoicesHaveBeenGenerated(true)
            setListOfInvoicesGeneratedSuccessfully([...listOfFamiliesWeTriedToGenerateInvoicesFor])
            getAllInvoices()
        } catch(e) {
            console.log(e)
        }
    }

    const updateTimesheets = (updatedTimesheet) => {
        setTimesheets(prev => prev.map(element => element.timesheetId === updatedTimesheet.timesheetId ? {...element, status: updatedTimesheet.status, families: updatedTimesheet.families} : element))
    }
    const updateInvoices = (updatedInvoice) => {
        setInvoices(prev => prev.map(element => element.invoiceId === updatedInvoice.invoiceId ? updatedInvoice : element))
    }
    const removeDeletedTimesheet = (id) => {
        setTimesheets(timesheets.filter(timesheet => timesheet.timesheetId !== id))
    }
    const removeDeletedInvoice = (id) => {
        setInvoices(invoices.filter(invoice => invoice.invoiceId !== id))
    }

    return(
        <div className="whole-billing-page">
            {quickView && <TimesheetAndInvoiceQuickView timesheetId={quickView} timesheets={timesheets} invoices={invoices} />}
            {adminCreateTimesheet && <AdminCreateTimesheet setAdminCreateTimesheet={setAdminCreateTimesheet} setTimesheets={setTimesheets} />}
            {adminCreateInvoice && <AdminCreateInvoice setAdminCreateInvoice={setAdminCreateInvoice} updateInvoices={updateInvoices} setInvoices={setInvoices}/>}
            {processingTimesheet && <SubmittingTimesheetPopup currentFamilyName={currentFamilyName}/>}
            {invoicesHaveBeenGenerated && <ReportOfInvoicesGenerated listOfInvoicesGeneratedSuccessfully={listOfInvoicesGeneratedSuccessfully} setInvoicesHaveBeenGenerated={setInvoicesHaveBeenGenerated} />}
            {props.openTimesheet && <EditTimesheet callForListOfFamilies={callForListOfFamilies} timesheets={timesheets} openTimesheet={props.openTimesheet} setShowNotes={props.setShowNotes} setTimesheets={setTimesheets} listOfFamilies={listOfFamilies} timesheet={props.openTimesheet} families={props.openTimesheet.families} setOpenUpTheTimesheet={props.setOpenTimesheet} generateInvoicesFromTimesheet={generateInvoicesFromTimesheet}  updateTimesheets={updateTimesheets} removeDeletedTimesheet={removeDeletedTimesheet} listOfTeachersTimesheetsForThisMonth={listOfTeachersTimesheetsForThisMonth} setOpenTimesheet={props.setOpenTimesheet} />}
            {/* {openTimesheet && <AdminEditTimesheet2023 timesheet={openTimesheet} setTimesheet={setOpenTimesheet} />} */}
            {props.openInvoice && <EditInvoice  editting={true} invoice={props.openInvoice} setOpenInvoice={props.setOpenInvoice} setShowNotes={props.setShowNotes} updateInvoices={updateInvoices} removeDeletedInvoice={removeDeletedInvoice} />}
            <h1 className="whole-billing-page__title">Billing</h1>
            {props.userData.Name === 'Prescott Blackler' && <OwnerMonthlyTimesheetOverview timesheets={timesheets} teachers={teachers} students={students} invoices={invoices} />}
            <div className="date-selector-wrapper">
                <TimesheetDateSelector month={month} setMonth={setMonth} year={year} setYear={setYear} />
                <div className='timesheet__create-timesheet-btn' onClick={() => setAdminCreateTimesheet(true)}>Create Timesheet</div>
                <div className='timesheet__create-timesheet-btn timesheet__create-invoice-btn' onClick={() => setAdminCreateInvoice(true)}>Create Invoice</div>
            </div>
            <div className="whole-billing-page__tab-wrapper">
                <h5 className="whole-billing-page__tabs" id="timesheet-tab" onMouseEnter={() => enterHoverAnimation("timesheet-tab", 'timesheets', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("timesheet-tab", 'timesheets', tab, schoolTab)} onClick={() => setTab('timesheets')}>Timesheets</h5>
                <h5 className="whole-billing-page__tabs" id="invoices-tab" onMouseEnter={() => enterHoverAnimation("invoices-tab", 'invoices', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("invoices-tab", 'invoices', tab, schoolTab)} onClick={() => setTab('invoices')}>Invoices</h5>
                <h5 className="whole-billing-page__tabs" style={!billingDataLoading && unbilledActiveStudentsCount > 0 ? {color: 'red'} : {color: 'black'}} id="unbilled-tab" onMouseEnter={() => enterHoverAnimation("unbilled-tab", 'unbilled', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("unbilled-tab", 'unbilled', tab, schoolTab)} onClick={() => setTab('unbilled')}>Active Students to Review</h5>
                {!billingDataLoading && unbilledActiveStudentsCount > 0 && <div className='unbilled-family-tab__number'>{unbilledActiveStudentsCount}</div>}
            </div>
            {tab !== 'unbilled' && <SchoolTabsTimesheet timesheets={timesheets} invoices={invoices} tab={tab} setSchoolTab={setSchoolTab} schoolTab={schoolTab} />}
            <div>
                {tab === 'timesheets' && <TimesheetsTab  teachers={teachers} timesheets={timesheets} schoolList={SCHOOL_LIST}  schoolTab={schoolTab} currentMonth={currentMonth} currentYear={currentYear} month={month} year={year} setListOfTeachersTimesheetsForThisMonth={setListOfTeachersTimesheetsForThisMonth} setOpenTimesheet={props.setOpenTimesheet} setQuickView={setQuickView} />}
                {tab === 'invoices' && <InvoicesTab schoolList={SCHOOL_LIST} invoices={invoices} timesheets={timesheets} setInvoices={setInvoices} teachers={teachers} schoolTab={schoolTab} setOpenInvoice={props.setOpenInvoice} />}
                {tab === 'unbilled' && <UnbilledTab familiesNotBilled={familiesNotBilled} otherUnbilledFamilies={otherUnbilledActiveFamilies} teachers={teachers} openStudentModal={props.openStudentModal} month={month} year={year} currentCalendarMonth={currentCalendarPeriod.month} currentCalendarYear={currentCalendarPeriod.year} loadError={billingDataError} loading={billingDataLoading} /> }
            </div>
        </div>
    )
}
export default Timesheets;
